/**
 * Form element customizations
 * -----------------------------------------------------------------------------
 *
 * Markup and Focus adjustments for select elements.
 * Validation functionality and other form related JS are provided elsewhere
 * depending on the type of form (Omni CMS LDP, Sendmail, etc).
 *
 * 11/11/2022 File Upload Updates
 * - Focus & accessibility:
 *   Removed file upload element focus adjustments and IE compatibility.
 *   We now use CSS and ::file-selector-button to add UND theming to the element.
 *   This means we don't need to use JS to manage input focus nor excessive ARIA
 *   attributes to provide an accessible file upload field.
 * - Multiple file browser support:
 *   Removed extra browser support for file inputs with the multiple attribute.
 *   Omni CMS LDP form assets do not have an option for the multiple attribute.
 *   Current browser support is adequate with widespread support except for
 *   Chrome on Android at Android OS versions >=4.x.
 *   @see https://en.wikipedia.org/wiki/Android_KitKat
 *   @see https://caniuse.com/#feat=input-file-multiple
 *   Also note the USWDS guidance: "Prefer one file per input. Some users might
 *   not know how to select multiple files in a file browser. Additionally, iOS
 *   does not allow multiple-file selection using the Files app."
 *   @ref https://designsystem.digital.gov/components/file-input/#section_5
 *
 * ToDo:
 * - Retire <select> JS modifications.
 *
 */

$( () => {

  // <select>
  // @status To be retired.
  $( '.form__select' ).each( function ( i, el ) {

    const $container     = $( this );
    const $text          = $container.find( '.form__select__text' );
    const $select        = $container.find( 'select' );
    const selectedOption = $select.find( 'option:selected' ).text();

    $text.text( selectedOption );

    $select
      .on( 'change', function ( e ) {

        const $selected = $select.find( 'option:selected' );

        $selected
          .attr( 'selected','selected' )
          .siblings( $selected )
          .removeAttr( 'selected', 'selected' );

        $text.text( $selected.text() );

      } )
      .on( 'focus', function ( e ) {
        $text.addClass( 'form__select__text--focus' );
      } )
      .on( 'blur', function ( e ) {
        $text.removeClass( 'form__select__text--focus' );
      } );

  } );

} );
